export const types = {
    UPDATE_WIDTH: 'UPDATE_WIDTH',
};

// Initial State
const state = {
    theWidth: 0,
};

// Getters
const getters = {
    theCurrentWidth: state => state.theWidth,
};

// Actions
const actions = {
    //value (width) passed in from the resize function
    updateWidth: ({ commit }, width) => commit(types.UPDATE_WIDTH, {width}),
};


// Mutations
const mutations = {
    [types.UPDATE_WIDTH](state, {width}) {
        state.theWidth = width;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};


// WEBPACK FOOTER //
// ./src/store/modules/windowWidth.js